<template>
	<router-view />
</template>

<script>
import { mapActions } from "vuex";
import { ElLoading } from "element-plus";

export default {
	name: "webApp",
	data() {
		return {};
	},
	created() {},
	mounted() {
		this.checkToken();
	},
	methods: {
		...mapActions(["getToken"]),
		async checkToken() {
			if (!this.$store.state.token) {
				let fullLoading = ElLoading.service({ fullscreen: true });
				this.getToken({})
					.then((res) => {
						if (res.code == 1) {
							let tmpData = JSON.parse(res.data);
							this.$store.state.token = tmpData.token;
							this.$store.state.siteConfig =
								tmpData.rows.siteConfig;
							this.$store.state.siteMenu = tmpData.rows.menu;
							this.$store.state.agreement =
								tmpData.rows.agreement;

							setTimeout(() => {
								fullLoading.close();
							}, 100);
						}
					})
					.catch((err) => {});
			}
		},
	},
	unmounted() {},
};
</script>
